export const testimonials = [
  {
    id: 1,
    name: "Marcus J.",
    role: "Frequent Buyer",
    avatar: "MJ",
    rating: 5,
    text: "The ACBuySpreadsheet system completely changed how I manage my orders. Before, I was tracking everything manually in random notes. Now I have a structured view of every purchase, shipping status, and cost breakdown. Absolutely worth it for anyone doing regular buys.",
  },
  {
    id: 2,
    name: "Elena K.",
    role: "Small Business Owner",
    avatar: "EK",
    rating: 5,
    text: "Running a boutique means I need to keep track of many orders across different categories. The ACBuy spreadsheet system gives me the transparency and control I needed. Cost comparison alone has saved me significant money on shipping decisions.",
  },
  {
    id: 3,
    name: "David R.",
    role: "E-commerce Reseller",
    avatar: "DR",
    rating: 5,
    text: "I have used several tracking methods over the years, and the ACBuySpreadsheet approach is by far the most organized. The structured data format makes it easy to spot trends, compare agent performance, and optimize my entire purchasing workflow.",
  },
  {
    id: 4,
    name: "Sophie L.",
    role: "Personal Shopper",
    avatar: "SL",
    rating: 4,
    text: "As someone who handles orders for multiple clients, the ACBuy spreadsheet system has been a game-changer. Everything is centralized, easy to reference, and the cost tracking helps me provide accurate quotes to my clients upfront.",
  },
  {
    id: 5,
    name: "James T.",
    role: "Supply Chain Analyst",
    avatar: "JT",
    rating: 5,
    text: "From a logistics perspective, the ACBuySpreadsheet system offers exactly what you need — structured data, clear comparison tables, and actionable insights. The shipping optimization data alone makes it worth adopting this workflow.",
  },
  {
    id: 6,
    name: "Olivia M.",
    role: "Online Retailer",
    avatar: "OM",
    rating: 5,
    text: "I was skeptical at first about using a spreadsheet-based system, but the ACBuySpreadsheet methodology proved me wrong. The level of detail and organization it brings to order management is remarkable. Highly recommend for anyone serious about efficiency.",
  },
];